import { Tooltip } from '@mui/material';
import { MouseEventHandler } from 'react';
import * as S from '../Dashboard.styled';

type Props = {
    children: React.ReactNode;
    onClick?: MouseEventHandler<HTMLLIElement>;
    margin?: string;
    style?: React.CSSProperties;
};

const DropdownItem = ({ children, onClick, margin, style }: Props) => {
    const isStringChild = typeof children === 'string';
    return (
        <>
            {isStringChild ? (
                <Tooltip title={children}>
                    <S.MenuItem margin={margin} onClick={onClick}>
                        <S.Item>
                            <S.Text style={{ ...style }}>{children}</S.Text>
                        </S.Item>
                    </S.MenuItem>
                </Tooltip>
            ) : (
                <S.MenuItem margin={margin} onClick={onClick}>
                    <S.Item>
                        <S.Text style={{ ...style }}>{children}</S.Text>
                    </S.Item>
                </S.MenuItem>
            )}
        </>
    );
};

export default DropdownItem;
